<template>
  <div class="project__add">
      <label for="title" >Name*</label>
      <div class="_flxrcenter">
        <input name="name" type="text" v-model="name" v-validate="'required'" @keyup.enter="create()" />
      </div>
      <span class="invalid">{{ errors.first('name') }}</span>
      <label for="title">E-Mail*</label>
      <div class="_flxrcenter">
        <input name="email" type="text" v-model="email" v-validate="'required|email'" @keyup.enter="create()" />
      </div>
      <span class="invalid">{{ errors.first('email') }}</span>
      <label for="title">Tenant*</label>
      <div class="_flxrcenter">
      <select name="tenant" v-model="tenantId" v-validate="'required'">
        <option></option>
        <option v-for="tenant in tenants" v-bind:key="tenant.id" :value="tenant.id">{{tenant.name}}</option>
      </select>
      </div>
      <span class="invalid">{{ errors.first('tenant') }}</span>
      <label for="title">Password*</label>
      <div class="_flxrcenter">
        <input name="password" type="text" v-validate="'required'" v-model="password" @keyup.enter="create()" />
      </div>
      <span class="invalid">{{ errors.first('password') }}</span>
      <div>
        <label><input type="checkbox" v-model="admin"> Admin</label>
      </div>
      <button title="Create project" class="button" @click="create()">Create</button>
      <button title="Close update" class="button cancel" @click="$emit('close')">
          <i class="material-icons">close</i>
      </button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'add',
  computed: {
    ...mapGetters(['tenants'])
  },
  data: () => ({
    name: '',
    email: '',
    password: '',
    tenantId: '',
    admin: false
  }),
  methods: {
    ...mapActions(['createUser']),
    create: function() {
      this.$validator.validate().then(valid => {
        if (valid) {
        const user = { name: this.name, email: this.email, password: this.password, tenantId: this.tenantId, admin: this.admin };
        this.createUser(user).then(() => {
          this.$emit('close')
        });
          }
      })
    }
  }
}
</script>
